import React from 'react'
import {ajax, getBrand, Status, getState, subscribe, unsubscribe, arrayFrom} from '../../twd'

const state = getState('overview.yield-grids', {
    method: 'HIGHEST'
})

export default () => {
    const [method, setMethod_] = React.useState(state.value.method || 'HIGHEST')
    const setMethod = React.useCallback((m) => {
        state.set({method:m})
        setMethod_(m)
    }, [])

    const [grids, setGrids] = React.useState([])
    const [status, setStatus] = React.useState(Status.LOADING)
    const [ts,setTs] = React.useState(Date.now())

    React.useEffect(() => {

        setGrids([])
        ;(async () => {
            try {
                setStatus(Status.LOADING)

                let {data} = await ajax({
                    url:'/esb/retailservice/yieldGridService/getYieldGridDataByType',
                    method: 'POST',
                    params: {
                        brand: 'etrade' || getBrand(),
                        yieldGridTypeList: [{
                            gridType: 'OVERVIEW',
                            yieldType: method
                        }]
                    }
                })

                let x = await data
                let t = method==='HIGHEST' ? 'Highest Yield' : 'Average Yield'
                let rs = arrayFrom(x[0].tables)
                    .map(a => Object.assign(a, {table:t}))
                setGrids(rs)

                setStatus(Status.LOADED)
            } catch(e) {
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

    }, [method,ts])


    React.useEffect(() => {
        let subId = subscribe('atmosphere_reconnected.overview_yield_grids', ({ts}) => {
            setTs(ts)
        })
        return () => {
            unsubscribe(subId)
        }
    }, [])


    return { method, setMethod, grids, status }
}



// WEBPACK FOOTER //
// ./src/overview/yield-grids/use-yield-grids.js